export const OrganizarCarpeta=Object.freeze({
    PERIODO:"PERIODO",
    COLABORADOR:"COLABORADOR",
})